<template>
    <span v-if="widgetReady">
        <span @click.prevent="showPendingChanges">
            <slot :hasPendingChange="hasPendingChange" v-show="hasCustomContent">

            </slot>
            <span v-if="!hasCustomContent && hasPendingChange">
                <div class="alert alert-warning" style="cursor: pointer">
                    <small class="text-primary">
                        <i class="fa fa-info-circle"></i> Upcoming Changes
                    </small>
                </div>
            </span>
        </span>
        <span>
            <upcoming-changes-modal :plan-id="currentPlan.planId" ref="upcomingChangesModal" style="z-index: 4000!important">

            </upcoming-changes-modal>
        </span>
    </span>
</template>

<script>
    import {api} from "../../../global/framework/api.js";
    import UpcomingChangesModal from "./UpcomingChangesModal.vue";
    import {mapGetters} from 'vuex';

    export default {
        name: "UpcomingPlanChanges",
        components: {UpcomingChangesModal},
        props: {planId: {type: [Number], required: true}},
        data() {
            return {
                widgetReady: false,
                currentPlan: {},
                futurePlan: {},
                currentTiers: {},
                futureOnlyPriceTiers: {},
                deletedOnlyPriceTiers: {},
                hasChange: false
            }
        },
        computed: {
            hasPendingChange() {
                if (this.hasChange) {
                    return true
                }
                return Boolean(this.futurePlan) && Boolean(this.futurePlan.planId);
            },
            hasCustomContent() {
                return Boolean(this.$scopedSlots.default);
            },
            ...mapGetters({showPricing: 'globalSettings/showPricing'})
        },
        async mounted() {
            let [current, future] = await Promise.all([
                api.getData('Shared', this.planId, 'GetCurrentPlanSettingsView'),
                api.getData('Shared', this.planId, 'GetFuturePlanSettingsView')
            ]);
            let data = await api.get('PriceTier', this.planId, '');
            this.currentTiers = data.current;
            this.futureOnlyPriceTiers = data.futureOnly;
            this.deletedOnlyPriceTiers = data.deletedOnly;
            this.currentPlan = current;
            this.futurePlan = future;
            if (this.tierHasChange(this.futureOnlyPriceTiers) || this.tierHasChange(this.currentTiers) || this.tierHasChange(this.deletedOnlyPriceTiers)) {
                this.hasChange = true;
            }
            this.widgetReady = true;
        },
        methods: {
            showPendingChanges() {
                if (this.hasPendingChange) {
                    this.$refs.upcomingChangesModal.showModal(this.planId);
                }
            },
            tierHasChange(tiers) {
                let result = false;
                if (tiers.length > 0) {
                    tiers.forEach(function (tier, index) {
                        if (tier.futureSettings != null) {
                            result = true;
                        }
                        if (tier.endDate != null) {
                            result = true;
                        }
                    });
                }
                return result;
            }
        }
    }
</script>

<style scoped>

</style>